<div class="exception-body access">
    <img src="assets/layout/images/logo-white.svg" alt="diamond-layout" class="logo">

    <div class="exception-content">
        <div class="exception-title">{{'ACCESS_DENIED'|translate}}</div>
        <div class="exception-detail">{{'YOU_DO_NOT_HAVE_THE_NECESSARY_PERMISSION'|translate}}</div>
        <a [routerLink]="['/']">{{'GO_TO_DASHBOARD'|translate}}</a>
    </div>
</div>